<ng-container *ngIf="!utils.isCollectionNullOrEmpty(_stocks)">

  <dx-data-grid
    id="lot-dx-grid"
    [dataSource]="_stocks"
    keyExpr="id"
    [hoverStateEnabled]="true"
    [allowColumnResizing]="true"
    [rowAlternationEnabled]="false"
    [showRowLines]="true"
    [showBorders]="true"
    [columnWidth]="160"
    (onCellPrepared)="onCellPrepared($event)">
    <dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>
    <dxo-state-storing
      [enabled]="true"
      type="localStorage"
      storageKey="stocksMatieresPremieresLot">
    </dxo-state-storing>
    <dxi-column dataField="id"
                alignment="center"
                caption="Actions"
                width="80px"
                [allowFiltering]="false"
                [allowGrouping]="false"
                [allowHiding]="false"
                [showInColumnChooser]="false"
                cellTemplate="actionsCellTemplate">
    </dxi-column>
    <dxi-column dataField="zdsLibelle"
                alignment="left"
                caption="Emplacement"
                [allowGrouping]="false"
                [allowFiltering]="false"
                cellTemplate="zdsCellTemplate">
    </dxi-column>
    <dxi-column [calculateCellValue]="getLotDisplayValue"
                alignment="left"
                caption="Lot"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="article"
                alignment="left"
                caption="Article"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="fournisseur"
                alignment="left"
                caption="Fournisseur"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="dateEntree"
                alignment="left"
                caption="Date Entrée"
                dataType="date"
                width="100px"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="dlc"
                alignment="left"
                caption="DLC/DDM"
                dataType="date"
                width="100px"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="quantiteUS"
                alignment="left"
                caption="Qté en US"
                cellTemplate="qteUSCellTemplate"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="quantiteKg"
                alignment="left"
                caption="Qté en kg"
                cellTemplate="qteKgCellTemplate"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="prixUnitaireKg"
                alignment="left"
                caption="PU H.T au kilo"
                cellTemplate="puHTKiloCellTemplate"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="prixUnitaireUS"
                alignment="left"
                caption="PU H.T en US"
                cellTemplate="puHTUSCellTemplate"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="prixUnitaire"
                alignment="left"
                caption="PU H.T en UF"
                cellTemplate="puHTUFCellTemplate"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="modifiePar"
                alignment="left"
                caption="Modifié par"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="dateDerniereModification"
                alignment="left"
                caption="Date de dernière modification"
                dataType="date"
                [allowGrouping]="false"
                [allowFiltering]="false">
    </dxi-column>

    <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
      <yo-button
        size="small"
        [theme]="ButtonThemeEnum.SECONDARY_INNER"
        (click)="openDialogSortie(cell.row.data)"
        iconClass="fas fa-minus"
        tooltip="Procéder manuellement à une sortie partielle ou totale d'un lot de matières premières"
      ></yo-button>
      <yo-button
        size="small"
        [theme]="ButtonThemeEnum.DEFAULT_INNER"
        (click)="openDialogEditLot(cell.row.data)"
        iconClass="fa fa-edit"
        tooltip="Modifier le lot"
      ></yo-button>
      <yo-button
        *ngIf="isImageButtonAvailable(cell.row.data)"
        iconClass="fas fa-camera"
        [theme]="ButtonThemeEnum.DEFAULT"
        (onClick)="openImageDialog(cell.row.data)"
        tooltip="Consulter la ou les photos"
        [label]="getImageCount(cell.row.data)">
      </yo-button>
    </div>
    <div *dxTemplate="let cell of 'zdsCellTemplate'">
      <div>
        <i class="fas fa-industry"></i> {{ cell.row.data.udpLibelle }}
      </div>
      <div>
        <i class="fas fa-cubes"></i> {{ cell.row.data.zdsLibelle }}
      </div>
    </div>
    <div *dxTemplate="let cell of 'qteUSCellTemplate'">
      {{ cell.row.data.quantiteUS | number:'1.4-4' }} {{ cell.row.data.uniteStockageAbreviation }}
    </div>
    <div *dxTemplate="let cell of 'qteKgCellTemplate'">
      {{ cell.row.data.quantiteKg | number:'1.4-4' }} Kg
    </div>
    <div *dxTemplate="let cell of 'puHTKiloCellTemplate'">
      {{ cell.row.data.prixUnitaireKg | currency:'EUR':'symbol':'1.4-4' }}
    </div>
    <div *dxTemplate="let cell of 'puHTUSCellTemplate'">
      {{ cell.row.data.prixUnitaireUS | currency:'EUR':'symbol':'1.4-4' }} / {{ cell.row.data.uniteStockageAbreviation }}
    </div>
    <div *dxTemplate="let cell of 'puHTUFCellTemplate'">
      {{ cell.row.data.prixUnitaire | currency:'EUR':'symbol':'1.4-4' }} / {{ cell.row.data.uniteFacturationAbreviation }}
    </div>

    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} résultat(s)">
    </dxo-pager>

  </dx-data-grid>

</ng-container>

<yo-dialog-modification-lots></yo-dialog-modification-lots>
<yo-dialog-sortie></yo-dialog-sortie>

<yo-image-list-popup
  [isOpened]="isImagePopupOpened"
  (onClose)="onImagePopupClose($event)"
  [values]="selectedStock?.images"
  [disabled]="true"
></yo-image-list-popup>

